import { UseQueryOptions, queryOptions } from '@tanstack/react-query';
import { getIssuableCoupons, IssuableCouponsParams } from '~/apis/coupon';

export const issuableCouponsOptions = (
  params: IssuableCouponsParams,
  { enabled }: Pick<UseQueryOptions, 'enabled'>,
) => {
  const options = queryOptions({
    queryKey: ['product', 'issuableCoupons', params],
    queryFn: () => getIssuableCoupons(params),
    select: (response) => response.data,
    enabled,
  });

  return options;
};
